import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { ThemeProvider } from '@kaseyaitglue/kaseya-ui';
import App from './App';

const container = document.getElementById('root');

if (container) {
  render(
    <React.StrictMode>
      <ThemeProvider theme="light">
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </React.StrictMode>,
    container,
  );
}
